import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const ContactPage: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <Navbar />

      {/* Main Contact Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-content mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            {/* Left Column: Contact Info */}
            <div className="flex-1">
              <h1 className="font-exo font-bold text-ebony-clay text-3xl lg:text-[48px] tracking-[2.4px] leading-tight mb-4">
                Contact Us
              </h1>
              <p className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal mb-12">
                Get in touch with our team to discuss your project needs
              </p>

              {/* Get In Touch */}
              <div className="mb-10">
                <h2 className="font-exo font-bold text-ebony-clay text-xl lg:text-2xl tracking-[1.2px] leading-normal mb-6">
                  Get In Touch
                </h2>

                <div className="space-y-4">
                  {/* Email */}
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <svg className="w-5 h-5 text-royal-blue" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                    </div>
                    <div>
                      <a
                        href="mailto:info@metalogix.solutions"
                        className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal hover:text-royal-blue transition-colors"
                      >
                        info@metalogix.solutions
                      </a>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <svg className="w-5 h-5 text-royal-blue" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                    </div>
                    <div>
                      <a
                        href="tel:+15551234567"
                        className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal hover:text-royal-blue transition-colors"
                      >
                        +27 60 678 4270
                      </a>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                      <svg className="w-5 h-5 text-royal-blue" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal">
                        32 Stadler Rd<br />Bloubergstrand, Cape Town, 7436
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Office Hours */}
              <div>
                <h2 className="font-exo font-bold text-ebony-clay text-xl lg:text-2xl tracking-[1.2px] leading-normal mb-6">
                  Office Hours
                </h2>
                <div className="space-y-2">
                  <p className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal">
                    Monday - Friday: 9:00 AM - 6:00 PM PST
                  </p>
                  <p className="font-proxima text-black text-base lg:text-lg tracking-[0.8px] leading-normal">
                    Saturday - Sunday: Closed
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Map */}
            <div className="flex-1">
              <div className="w-full h-[400px] lg:h-[500px] rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3304.956894673596!2d18.441727315205856!3d-33.81543328067164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc42c4c5c5c5c5%3A0x5c5c5c5c5c5c5c5c!2s32%20Stadler%20Rd%2C%20Bloubergstrand%2C%20Cape%20Town%2C%207436!5e0!3m2!1sen!2sza!4v1640000000000!5m2!1sen!2sza"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Office Location - 32 Stadler Rd, Bloubergstrand, Cape Town, 7436"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
